import styled from 'styled-components';

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;

  .overlapping-item {
    margin-left: -1rem;
  }

  svg {
    width: 3rem;
    height: 3rem;
  }
`;

export const CountContainer = styled.div`
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(theme) => theme.theme.colors?.text.interactive};
  border-radius: 50%;
`;
